<template>
  <div class="altura">
    <b-row>
      <b-col cols="12" class="mb-2 mb-lg-4">
        <PageTitle class="mt-2" title="Política de devolução" />
      </b-col>
    </b-row>
    <ReturnPolicyComponent :isTerm="true" />
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import ReturnPolicyComponent from '@/components/Shopkeeper/ReturnPolicyComponent.vue';

export default {
  name: 'ReturnPolicy',

  components: {
    PageTitle,
    ReturnPolicyComponent,
  },
};
</script>

<style scoped>
.altura {
  min-height: 80vh;
}
</style>
